<div class="page-header">
  <div class="header-left">
    <div class="header-icon">
      <i class="fa-solid fa-rotate-left"></i>
    </div>
    <div>
      <h1>Return History</h1>
      <p>View historical return and refund records</p>
    </div>
  </div>
</div>

<div class="filters-panel">
  <div class="filters-left">
    <div class="search-input-wrapper">
      <i class="fa-solid fa-magnifying-glass search-icon"></i>
      <input type="text" placeholder="Search returns..." class="search-input" />
    </div>

    <div ngbDropdown class="d-inline-block" container="body">
      <button type="button" class="btn btn-filter" ngbDropdownToggle>
        <i class="fa-solid fa-calendar-days"></i> Filter by Date
      </button>
      <div ngbDropdownMenu class="p-1">
        <button ngbDropdownItem>Today</button>
        <button ngbDropdownItem>This week</button>
        <button ngbDropdownItem>This Month</button>
        <button ngbDropdownItem>Custom</button>
      </div>
    </div>

    <div ngbDropdown class="d-inline-block" container="body">
      <button type="button" class="btn btn-filter" ngbDropdownToggle>
        <i class="fa-solid fa-filter"></i> Filter by Status
      </button>
      <div ngbDropdownMenu class="p-1">
        <button ngbDropdownItem>Accepted</button>
        <button ngbDropdownItem>Rejected</button>
      </div>
    </div>
  </div>
</div>

<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <i class="fa-solid fa-clock-rotate-left"></i>
      <div>
        <h3>Return Records</h3>
        <span class="panel-subtitle">All processed return requests</span>
      </div>
    </div>
  </div>

  <div class="panel-body">
    <div class="table-responsive">
      <table class="table align-middle mb-0">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Waiter</th>
            <th>Reason</th>
            <th>Affected Item</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span style="color: var(--accent); font-weight: 600;">#709357</span>
            </td>
            <td>
              <span style="color: var(--text-primary); font-weight: 500;">Akan Chambers</span>
            </td>
            <td>
              <span style="color: var(--text-secondary);">Expired Item</span>
            </td>
            <td>
              <span style="color: var(--text-primary);">Coca-cola 50cl bottle</span>
            </td>
            <td>
              <span class="status-badge status-active">
                <span class="status-dot"></span>
                Accepted
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
